<template>
    <ul class="filter-menu">
        <li style="width: 18%">
            <a class="btn btn--border-only">
                <div style="display: flex; align-items: center; width: 100%;">
                    <div style="margin-right: 5px;">
                        <icon name="search"/>
                    </div>
                    <input type="text" class="input input-search" placeholder="Por nome da empresa"
                        @input="onSearchChange($event.target.value)">
                </div>
            </a>
        </li>
        <li @click="onClickOrdination('name')">
            <a href="javascript:void(0)" class="btn btn--border-only">
                Nome              
                <span style="margin-left: 10px;" class="target__title" v-if="ordinations.name != null">
                    <fa :icon="getIconOrdination('name')" size="lg" />
                </span>
            </a>
        </li>
        <li @click="onClickOrdination('dateCreated')">
            <a href="javascript:void(0)" class="btn btn--border-only">
                Data de criação              
                <span style="margin-left: 10px;" class="target__title" v-if="ordinations.dateCreated != null">
                    <fa :icon="getIconOrdination('dateCreated')" size="lg" />
                </span>
            </a>
        </li>
        <li @click="onClickOrdination('requestsFinished')">
            <a href="javascript:void(0)" class="btn btn--border-only">
                Pedidos finalizados               
                <span style="margin-left: 10px;" class="target__title" v-if="ordinations.requestsFinished != null">
                    <fa :icon="getIconOrdination('requestsFinished')" size="lg" />
                </span>
            </a>
        </li>
        <li @click="onClickOrdination('requestsCanceled')">
            <a href="javascript:void(0)" class="btn btn--border-only">
                Pedidos cancelados               
                <span style="margin-left: 10px;" class="target__title" v-if="ordinations.requestsCanceled != null">
                    <fa :icon="getIconOrdination('requestsCanceled')" size="lg" />
                </span>
            </a>
        </li>
        <li>
            <a class="btn btn--primary" v-if="!loading" style="color: #FFF;" @click="apply()">
                OK
            </a>
            <a class="btn btn--primary" v-else style="color: #FFF;">
                ...
            </a>
        </li>
    </ul>
</template>
<script>
    import {  mapGetters, mapState, mapActions } from 'vuex';

    import utils from '../../../utils/index';
    import moment from 'moment';
    import _ from 'lodash';

    import { Portuguese } from 'flatpickr/dist/l10n/pt'

    export default {
        components: {
        },
        props: ['loading'],
        data(){
            return {
                form: {
                    search: null
                },
                ordinations: {
                    name: undefined,
                    dateCreated: undefined,
                    requestsFinished: undefined,
                    requestsCanceled: undefined
                },
                selectedDays: 0,
                filterDatetimeSelectorConfig: {
                    altInput: true,
                    altFormat: 'd/m/Y H:i:S',
                    dateFormat: 'Z',
                    mode: 'range',
                    locale: Portuguese,
                    enableTime: false,
                    clickOpens: false,
                    defaultDate: [new Date(), new Date()]
                },
                searchTimeout: null
            }
        },
        methods: {
            ...mapActions('toast',['showToast']),
            onClickOrdination(type) {
                if(this.ordinations[type] == 'desc')
                    this.ordinations[type] = 'asc'
                else if(this.ordinations[type] == 'asc')
                    this.ordinations[type] = undefined
                else 
                    this.ordinations[type] = 'desc'

                this.apply()
            },
            getIconOrdination(type) {
                if(this.ordinations[type] === 'asc') return 'sort-amount-up-alt'
                else if(this.ordinations[type] === 'desc') return 'sort-amount-down-alt'
                return 'sort-amount-down-alt'
            }, 
            onFilterChange(){
                this.$emit('clean-selection')
                this.apply()
            },
            onSearchChange(search) {
                if(this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.form.search = search
                    this.onFilterChange()
                }, 500)
            },
            apply(params = {}){
                const filterData = utils.removeReactivity(this.form)

                const ordinationData = utils.removeReactivity(this.ordinations)
                this.$emit('search', {
                    filterData,
                    ordinationData,
                    params
                })
            }
        }
    }
</script>

<style scoped>
    .page--crud {
        display: flex;
        flex-grow: 1;
        justify-content: center;
        background-color: var(--bg-color--7)
    }
    .page--crud > div {
        width: 96%;
        text-align: center;
        padding-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .page--crud > div > h3 {
        padding-bottom: 30px;
    }

    .page--crud >>> a .colorizable {
        fill: var(--font-color)
    }

    .page--crud >>> a.active .colorizable {
        fill: var(--font-color--primary)
    }


    /* title */

    h3.title {
        font-size: 16px;
        text-transform: uppercase;
        color: var(--font-color--7)
    }

    /* filter */

    ul.filter-menu {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding-bottom: 20px;
    }
    ul.filter-menu li {
        margin: 0 5px;
        position: relative;
    }
    ul.filter-menu >>> li.datetime-selector input {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        overflow: hidden;
        z-index: -1;
    }
    ul.filter-menu li a {
        height: 32px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        color: var(--font-color--7)
    }
    ul.filter-menu li a.right-padding {
        padding-right: 30px;
    }
    ul.filter-menu li a.clear-filter {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    ul.filter-menu li a .primary {
        color: var(--font-color--primary);
        font-weight: 600;
    }
    ul.filter-menu li a .dot-separator.primary {
        background-color: var(--border-color--primary)
    }
    ul.filter-menu li a .secondary {
        color: var(--font-color--secondary);
        font-weight: 600;
    }
    ul.filter-menu li a .dot-separator.secondary {
        background-color: var(--border-color--secondary)
    }
    ul.filter-menu li a .terciary {
        color: var(--font-color--terciary);
        font-weight: 600;
    }
    ul.filter-menu li a .dot-separator.terciary {
        background-color: var(--border-color--terciary)
    }

    /* summary */

    .summary__item {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        padding: 0 20px;
        border-right: 1px solid var(--bg-color--8)
    }

    .summary__item.border-left {
        border-left: 1px solid var(--bg-color--8)
    }

    .summary__item:last-child {
        border-right: 0
    }

    /* footer */

    div.footer {
        padding: 40px 0;
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
    }

    div.footer a {
        text-transform: uppercase;
    }

    div.footer span {
        font-weight: 600;
    }

    div.footer .left-side {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-left: 20px;
    }

    div.footer .left-side > * {
        margin: 0 5px;
    }

    div.footer .right-side {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-right: 20px;
    }

    div.footer .right-side .group {
        border: 1px solid var(--bg-color--9);
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 15px;
        border-radius: 10px;
        margin-right: 10px;
        height: 32px;
    }

    div.footer .right-side > a {
        height: 30px;
    }

    div.footer .right-side .group .dot-separator {
        margin: 0 10px;
    }

    div.footer .right-side .group span {
        margin-right: 10px;
        white-space: nowrap
    }

    div.footer .right-side > * {
        margin: 0 5px;
    }

    div.footer .right-side > *:last-child {
        margin: 0 0 0 5px;
    }

    .input-search {
        font-size: 1em;
        margin: 0;
        padding: 0;
        width: 100%;
    }
    .input-search:focus, .input-search:hover {
        border: none;
    }
    .input-search::placeholder {
        font-size: 1em;
        text-transform: none;
        opacity: .5;
    }
</style>